import { useState } from 'react';
import PanelLayout from '../components/PanelLayout';
import { historyData } from '@/mocks/therapistPanel';

const tabs = [
  { id: 'active', label: 'Aktif Görüşmeler' },
  { id: 'pending', label: 'Bekleyen Talepler' },
  { id: 'completed', label: 'Sonuçlanan Görüşmeler' },
  { id: 'hired', label: 'İşe Başlanan İşletmeler' },
  { id: 'archived', label: 'Arşivlenen Görüşmeler' },
];

const statusBadge = (status: string) => {
  const map: Record<string, string> = {
    'görüşme başladı': 'bg-dark-teal-50 text-dark-teal-500',
    beklemede: 'bg-amber-50 text-amber-600',
    'süreç kapandı': 'bg-gray-100 text-gray-500',
    'işe başladı': 'bg-green-50 text-green-600',
    'uygun bulunmadı': 'bg-gray-100 text-gray-500',
  };
  return map[status] || 'bg-gray-100 text-gray-500';
};

export default function GecmisPage() {
  const [activeTab, setActiveTab] = useState('active');

  const data = historyData[activeTab as keyof typeof historyData] || [];

  return (
    <PanelLayout>
      <div className="max-w-4xl mx-auto">
        <div className="mb-6">
          <h1 className="text-xl md:text-2xl font-bold text-deep-navy-500">Geçmiş Görüşmeler</h1>
          <p className="text-sm text-gray-500 mt-1">
            Tüm görüşme ve talep geçmişinizi kategorilere göre inceleyin.
          </p>
        </div>

        {/* Tabs */}
        <div className="flex gap-1 mb-6 overflow-x-auto pb-1 bg-gray-50 p-1 rounded-xl">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-3 py-2 rounded-lg text-xs font-medium whitespace-nowrap transition-colors cursor-pointer ${
                activeTab === tab.id
                  ? 'bg-white text-dark-teal-500 shadow-sm'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="space-y-3">
          {data.map((item: any) => (
            <div key={item.id} className="bg-white rounded-xl border border-gray-100 p-4">
              <div className="flex items-center justify-between">
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-sm font-semibold text-deep-navy-500">{item.spaType}</span>
                    <span className={`px-2 py-0.5 rounded-full text-[10px] font-medium ${statusBadge(item.status)}`}>
                      {item.status}
                    </span>
                  </div>
                  <p className="text-xs text-gray-500">{item.city}</p>
                  {item.startDate && (
                    <p className="text-xs text-gray-400 mt-1">Başlangıç: {item.startDate}</p>
                  )}
                  {item.endDate && (
                    <p className="text-xs text-gray-400 mt-1">Bitiş: {item.endDate}</p>
                  )}
                  {item.requestDate && (
                    <p className="text-xs text-gray-400 mt-1">Talep: {item.requestDate}</p>
                  )}
                  {item.archiveDate && (
                    <p className="text-xs text-gray-400 mt-1">Arşiv: {item.archiveDate}</p>
                  )}
                  {item.reason && (
                    <p className="text-xs text-gray-500 mt-1">Neden: {item.reason}</p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {data.length === 0 && (
          <div className="text-center py-16">
            <span className="w-12 h-12 flex items-center justify-center mx-auto text-gray-300 mb-3">
              <i className="ri-history-line text-3xl" />
            </span>
            <p className="text-sm text-gray-500">Bu kategoride kayıt bulunmuyor.</p>
          </div>
        )}
      </div>
    </PanelLayout>
  );
}